var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center"},[_c('v-alert',{attrs:{"outlined":"","type":"info","border":"bottom"}},[_vm._v(" "+_vm._s(_vm.empleadoNoRegistradoMensaje)+" con la identificacion "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.identificacionInput))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }